/**
 * 공유 페이지(비회원)의 다이얼로그 뒤 — 깔린 서비스 화면을 흐리게 비친다(소재 상세 `MediaDetailDialog` 의 `publicView`).
 */
export const PUBLIC_SHARE_BACKDROP_SX = { backdropFilter: 'blur(8px)', bgcolor: 'rgba(20,22,28,0.35)' } as const;
